import { RouteLocationNormalizedLoaded, RouteRecordRaw } from 'vue-router';
import Layout from '@/components/layout/index.vue';
import layout2 from '@/newPages/layout2.vue';
import Welcome from '@/pages/welcome/index.vue';
import Login2 from '@/pages/login/index.vue';
import { useLayoutStore } from '@/store';

function getProps(route: RouteLocationNormalizedLoaded) {
  return route.query;
}

// 系统生成路由
export const routers: Array<RouteRecordRaw> = [
  // {
  //   path: '/Login2',
  //   component: Login2,
  //   name: 'Login2',
  //   meta: {
  //     title: '登录',
  //   },
  // },
  // {
  //   path: '/', // ✅ 默认首页页面，改为 home
  //   component: () => import('@/pages/home/index.vue'),
  //   name: 'root',
  //   meta: {
  //     title: '首页',
  //   },
  // },
  {
    path: '/', // ✅ 默认首页页面，改为 直接home
    component: () => import('@/newPages/sentry/index.vue'),
    name: 'root',
    meta: {
      title: '首页',
    },
  },
  {
    path: '/home',
    component: () => import('@/newPages/sentry/index.vue'),
    name: 'home',
    meta: {
      title: '首页',
    },
  },
  {
    path: '/login',
    component: () => import('@/newPages/login.vue'),
    name: 'login',
    meta: {
      title: '登录',
    },
  },
  // 园区系统（Vue2 项目嵌入）
  {
    path: '/yuanqu',
    component: () => import('@/pages/yuanqu/index.vue'),
    name: 'yuanqu',
    meta: {
      title: '数字园区',
    },
  },
  {
    path: '/devicePoints',
    component: () => import('@/newPages/devicePoints/index.vue'),
    name: 'devicePoints',
    meta: {
      title: '布点系统',
    },
  },
  {
    path: '/patrol',
    component: () => import('@/newPages/patrol/index.vue'),
    redirect: '/patrol/overview',
    name: 'patrol',
    meta: { title: '巡检管理' },
    children: [
      {
        path: 'overview',
        component: () => import('@/newPages/patrol/overview/index.vue'),
        name: 'patrolOverview',
        meta: { title: '巡检管理中心' },
      },
      {
        path: 'tasks',
        component: () => import('@/newPages/patrol/tasks/index.vue'),
        name: 'patrolTasks',
        meta: { title: '查看巡检任务' },
      },
      {
        path: 'template',
        component: () => import('@/newPages/patrol/template/index.vue'),
        name: 'patrolTemplate',
        meta: { title: '检查项模板' },
      },
      {
        path: 'project-items',
        component: () => import('@/newPages/patrol/project-items/index.vue'),
        name: 'patrolProjectItems',
        meta: { title: '项目检查项' },
      },
      {
        path: 'assignments',
        component: () => import('@/newPages/patrol/assignments/index.vue'),
        name: 'patrolAssignments',
        meta: { title: '发布巡检任务' },
      },
      {
        path: 'faults',
        component: () => import('@/newPages/patrol/faults/index.vue'),
        name: 'patrolFaults',
        meta: { title: '异常与维修' },
      },
      {
        path: 'repairs',
        component: () => import('@/newPages/patrol/repairs/index.vue'),
        name: 'patrolRepairs',
        meta: { title: '维修工单' },
      },
      {
        path: 'fraud-records',
        component: () => import('@/newPages/patrol/fraud-records/index.vue'),
        name: 'patrolFraudRecords',
        meta: { title: '风险审查' },
      },
      {
        path: 'summaries',
        component: () => import('@/newPages/patrol/summaries/index.vue'),
        name: 'patrolSummaries',
        meta: { title: '巡检报告' },
      },
    ],
  },
  // {
  //   path: '/mcLogin',
  //   component: () => import('@/newPages/login-MingChang.vue'),
  //   name: 'mcLogin',
  //   meta: {
  //     title: '登录',
  //   },
  // },
  {
    path: '/ht',
    component: layout2,
    redirect: {
      name: 'welcome2',
    },
    name: 'ht',
    meta: {
      title: '首页',
    },
    // redirect: {
    //   name: 'welcome',
    // },
    children: [
      {
        path: 'userInfo',
        component: () => import('@/newPages/ht/userInfo.vue'),
        name: 'userInfo',
        meta: { title: '个人信息' },
      },
      {
        path: 'welcome2',
        component: () => import('@/newPages/ht/welcome2.vue'),
        name: 'welcome2',
        meta: { title: '欢迎' },
      },
      {
        path: 'formUserLogin',
        component: () => import('@/newPages/ht/formUserLogin.vue'),
        name: 'formUserLogin',
        meta: { title: '用户管理' },
      },
      {
        path: 'formRole',
        component: () => import('@/newPages/ht/formRole.vue'),
        name: 'formRole',
        meta: { title: '角色管理' },
      },
      {
        path: 'formPermission',
        component: () => import('@/newPages/ht/formPermission.vue'),
        name: 'formPermission',
        meta: { title: '权限管理' },
      },
      {
        path: 'formMenu',
        component: () => import('@/newPages/ht/formMenu.vue'),
        name: 'formMenu',
        meta: { title: '菜单管理' },
      },
      {
        path: 'formTOperationLog',
        component: () => import('@/newPages/ht/formTOperationLog.vue'),
        name: 'formTOperationLog',
        meta: { title: '操作日志管理' },
      },
      {
        path: 'formDBKeys',
        component: () => import('@/newPages/ht/formDBKeys.vue'),
        name: 'formDBKeys',
        meta: { title: '项目密钥管理' },
      },
      {
        path: 'formModel',
        component: () => import('@/newPages/ht/formModel.vue'),
        name: 'formModel',
        meta: { title: '模型管理' },
      },
      {
        path: 'formSystemConfig',
        component: () => import('@/newPages/ht/formSystemConfig.vue'),
        name: 'formSystemConfig',
        meta: { title: '系统配置' },
      },
      {
        path: 'formScoreTemplate',
        component: () => import('@/newPages/ht/formScoreTemplate.vue'),
        name: 'formScoreTemplate',
        meta: { title: '评分模板管理' },
      },
      // 业务模块路由配置
      {
        path: 'formProject',
        component: () => import('@/newPages/ht/yw/formProject.vue'),
        name: 'formProject',
        meta: { title: '项目管理' },
      },
      {
        path: 'formArea',
        component: () => import('@/newPages/ht/yw/formArea.vue'),
        name: 'formArea',
        meta: { title: '分区管理' },
      },
      {
        path: 'formAnalog',
        component: () => import('@/newPages/ht/yw/formAnalog.vue'),
        name: 'formAnalog',
        meta: { title: '模拟量管理' },
      },
      {
        path: 'formBuilding',
        component: () => import('@/newPages/ht/yw/formBuilding.vue'),
        name: 'formBuilding',
        meta: { title: '建筑物管理' },
      },
      {
        path: 'formController',
        component: () => import('@/newPages/ht/yw/formController.vue'),
        name: 'formController',
        meta: { title: '控制器管理' },
      },
      {
        path: 'formCtrrooms',
        component: () => import('@/newPages/ht/yw/formCtrrooms.vue'),
        name: 'formCtrrooms',
        meta: { title: '消控室管理' },
      },
      {
        path: 'formDevice',
        component: () => import('@/newPages/ht/yw/formDevice.vue'),
        name: 'formDevice',
        meta: { title: '设备管理' },
      },
      {
        path: 'formDevtype',
        component: () => import('@/newPages/ht/yw/formDevType.vue'),
        name: 'formDevType',
        meta: { title: '设备类型管理' },
      },
      {
        path: 'formFactorts',
        component: () => import('@/newPages/ht/yw/formFactorts.vue'),
        name: 'formFactorts',
        meta: { title: '厂商维护管理' },
      },
      {
        path: 'formLayer',
        component: () => import('@/newPages/ht/yw/formLayer.vue'),
        name: 'formLayer',
        meta: { title: '楼层列表管理' },
      },
      {
        path: 'formDevStatusHistory2',
        component: () => import('@/newPages/ht/formDevStatusHistory.vue'),
        name: 'formDevStatusHistory2',
        meta: { title: '设备状态历史记录' },
      },
      {
        path: 'formLoop',
        component: () => import('@/newPages/ht/yw/formLoop.vue'),
        name: 'formLoop',
        meta: { title: '回路列表管理' },
      },
      {
        path: 'formMultiwiredial',
        component: () => import('@/newPages/ht/yw/formMultiwiredial.vue'),
        name: 'formMultiwiredial',
        meta: { title: '多线盘管理' },
      },
      {
        path: 'formAttendants2',
        component: () => import('@/newPages/ht/yw/formAttendants.vue'),
        name: 'formAttendants2',
        meta: { title: '消控室人员管理' },
      },
      {
        path: 'formConfigs2',
        component: () => import('@/newPages/ht/yw/formConfigs.vue'),
        name: 'formConfigs2',
        meta: { title: '系统配置管理' },
      },
      {
        path: 'formDrillrecords2',
        component: () => import('@/newPages/ht/yw/formDrillrecords.vue'),
        name: 'formDrillrecords2',
        meta: { title: '演练记录管理' },
      },
      {
        path: 'formDutyrecords2',
        component: () => import('@/newPages/ht/yw/formDutyrecords.vue'),
        name: 'formDutyrecords2',
        meta: { title: '消控室值班记录管理' },
      },
      {
        path: 'formDutyrecordsplat2',
        component: () => import('@/newPages/ht/yw/formDutyrecordsplat.vue'),
        name: 'formDutyrecordsplat2',
        meta: { title: '平台值班记录' },
      },
      {
        path: 'formGatewayrecords2',
        component: () => import('@/newPages/ht/yw/formGatewayrecords.vue'),
        name: 'formGatewayrecords2',
        meta: { title: '网关记录管理' },
      },
      {
        path: 'formGateways2',
        component: () => import('@/newPages/ht/yw/formGateways.vue'),
        name: 'formGateways2',
        meta: { title: '单位网关列表' },
      },
      {
        path: 'formInspectrecords2',
        component: () => import('@/newPages/ht/yw/formInspectrecords.vue'),
        name: 'formInspectrecords2',
        meta: { title: '单位物资年检记录' },
      },
      {
        path: 'formLocaltcprecords2',
        component: () => import('@/newPages/ht/yw/formLocaltcprecords.vue'),
        name: 'formLocaltcprecords2',
        meta: { title: '本地TCP记录管理' },
      },
      {
        path: 'formOnofflinerecords2',
        component: () => import('@/newPages/ht/yw/formOnofflinerecords.vue'),
        name: 'formOnofflinerecords2',
        meta: { title: '单位本地平台/网关连接记录' },
      },
      {
        path: 'formOperationsplat2',
        component: () => import('@/newPages/ht/yw/formOperationsplat.vue'),
        name: 'formOperationsplat2',
        meta: { title: '平台账号操作记录' },
      },
      {
        path: 'formPageevents2',
        component: () => import('@/newPages/ht/yw/formPageevents.vue'),
        name: 'formPageevents2',
        meta: { title: '页面事件记录' },
      },
      {
        path: 'formPutoffrecords2',
        component: () => import('@/newPages/ht/yw/formPutoffrecords.vue'),
        name: 'formPutoffrecords2',
        meta: { title: '单位延期记录' },
      },
      {
        path: 'formRepairrecords2',
        component: () => import('@/newPages/ht/yw/formRepairrecords.vue'),
        name: 'formRepairrecords2',
        meta: { title: '单位报警处理' },
      },
      {
        path: 'formStoragebox2',
        component: () => import('@/newPages/ht/yw/formStoragebox.vue'),
        name: 'formStoragebox2',
        meta: { title: '存储箱管理' },
      },
      {
        path: 'formStorageboxtype2',
        component: () => import('@/newPages/ht/yw/formStorageboxtype.vue'),
        name: 'formStorageboxtype2',
        meta: { title: '存储箱类型' },
      },
      {
        path: 'formSupplies2',
        component: () => import('@/newPages/ht/yw/formSupplies.vue'),
        name: 'formSupplies2',
        meta: { title: '物资信息表' },
      },
      {
        path: 'formSuppliesType',
        component: () => import('@/newPages/ht/yw/formSuppliesTypeTb.vue'),
        name: 'formSuppliesType',
        meta: { title: '物资类型管理' },
      },
      {
        path: 'formSystype2',
        component: () => import('@/newPages/ht/yw/formSystype.vue'),
        name: 'formSystype2',
        meta: { title: '物资信息类型' },
      },
      {
        path: 'formTimeoutrecords2',
        component: () => import('@/newPages/ht/yw/formTimeoutrecords.vue'),
        name: 'formTimeoutrecords2',
        meta: { title: '单位超时记录' },
      },
      {
        path: 'formBuildInfo',
        component: () => import('@/newPages/ht/yw/formBuildInfo.vue'),
        name: 'formBuildInfo',
        meta: { title: '建筑物信息管理' },
      },
      {
        path: 'formPlan',
        component: () => import('@/newPages/ht/yw/formPlan.vue'),
        name: 'formPlan',
        meta: { title: '维保任务计划' },
      },
      {
        path: 'formMaintenanceQualification',
        component: () => import('@/newPages/ht/yw/formMaintenanceQualification.vue'),
        name: 'formMaintenanceQualification',
        meta: { title: '维保资质申请管理' },
      },
      {
        path: 'formMaintenanceQualificationType',
        component: () => import('@/newPages/ht/yw/formMaintenanceQualificationType.vue'),
        name: 'formMaintenanceQualificationType',
        meta: { title: '维保资质类型管理' },
      },
      {
        path: 'formSceneConstruction',
        component: () => import('@/newPages/ht/yw/sceneConstruction/index.vue'),
        name: 'formSceneConstruction',
        meta: { title: '场景构造管理' },
      },
      {
        path: 'formDict',
        component: () => import('@/newPages/ht/formDict.vue'),
        name: 'formDict',
        meta: { title: '字典管理' },
      },
      // v1 哨兵模块
      {
        path: 'v1',
        name: 'v1Dashboard',
        component: () => import('@/newPages/ht/shaoB/index.vue'),
        meta: { title: '监控中心' },
      },
      {
        path: 'v1/fault',
        name: 'v1Fault',
        component: () => import('@/newPages/ht/shaoB/index.vue'),
        meta: { title: '故障台账' },
      },
      {
        path: 'v1/fire-door',
        name: 'v1FireDoor',
        component: () => import('@/newPages/ht/shaoB/index.vue'),
        meta: { title: '防火门监控' },
      },
      {
        path: 'v1/fire-alarm',
        name: 'v1FireAlarm',
        component: () => import('@/newPages/ht/shaoB/index.vue'),
        meta: { title: '火灾报警系统' },
      },
      {
        path: 'v1/extinguish',
        name: 'v1Extinguish',
        component: () => import('@/newPages/ht/shaoB/index.vue'),
        meta: { title: '灭火系统' },
      },
      {
        path: 'v1/electrical',
        name: 'v1Electrical',
        component: () => import('@/newPages/ht/shaoB/index.vue'),
        meta: { title: '电气火灾系统' },
      },
      {
        path: 'v1/duty',
        name: 'v1Duty',
        component: () => import('@/newPages/ht/shaoB/index.vue'),
        meta: { title: '值班事务' },
      },
      {
        path: 'v1/record',
        name: 'v1Record',
        component: () => import('@/newPages/ht/shaoB/index.vue'),
        meta: { title: '消防档案' },
      },
      {
        path: 'v1/ledger',
        name: 'v1Ledger',
        component: () => import('@/newPages/ht/shaoB/index.vue'),
        meta: { title: '消防台账' },
      },
      {
        path: 'v1/maintenance',
        name: 'v1Maintenance',
        component: () => import('@/newPages/ht/shaoB/index.vue'),
        meta: { title: '维保测试' },
      },
      {
        path: 'v1/safety',
        name: 'v1Safety',
        component: () => import('@/newPages/ht/shaoB/index.vue'),
        meta: { title: '安全指数' },
      },
      {
        path: 'v1/alert',
        name: 'v1Alert',
        component: () => import('@/newPages/ht/shaoB/index.vue'),
        meta: { title: '报警详情' },
      },
    ],
  },
  {
    path: '/main',
    component: Layout,
    name: 'main',
    props: getProps,
    redirect: {
      name: 'welcome',
    },
    meta: {
      title: '主页',
      showOnly: true,
    },
    children: [
      {
        path: 'welcome',
        component: Welcome,
        name: 'welcome',
        meta: { title: '欢迎' },
      },
      {
        path: 'formSysMenu',
        component: () =>
          useLayoutStore().supportColumn
            ? import('@/pages/upms/formSysMenu/formSysColumnMenu.vue')
            : import('@/pages/upms/formSysMenu/index.vue'),
        name: 'formSysMenu',
        meta: { title: '菜单列表' },
      },
      {
        path: 'formSysUser',
        component: () => import('@/pages/upms/formSysUser/index.vue'),
        name: 'formSysUser',
        meta: { title: '用户列表' },
      },
      {
        path: 'formSysDept',
        component: () => import('@/pages/upms/formSysDept/index.vue'),
        name: 'formSysDept',
        meta: { title: '部门列表' },
      },
      {
        path: 'formSysRole',
        component: () => import('@/pages/upms/formSysRole/index.vue'),
        name: 'formSysRole',
        meta: { title: '角色管理' },
      },
      {
        path: 'formSysDataPerm',
        component: () => import('@/pages/upms/formSysDataPerm/index.vue'),
        name: 'formSysDataPerm',
        meta: { title: '数据权限管理' },
      },
      {
        path: 'formSysPermCode',
        component: () => import('@/pages/upms/formSysPermCode/index.vue'),
        name: 'formSysPermCode',
        meta: { title: '权限字管理' },
      },
      {
        path: 'formSysPerm',
        component: () => import('@/pages/upms/formSysPerm/index.vue'),
        name: 'formSysPerm',
        meta: { title: '权限资源管理' },
      },
      {
        path: 'formSysLoginUser',
        component: () => import('@/pages/upms/formSysLoginUser/index.vue'),
        name: 'formSysLoginUser',
        meta: { title: '在线用户' },
      },
      // 岗位模块路由配置
      {
        path: 'formSysPost',
        component: () => import('@/pages/upms/formSysPost/index.vue'),
        name: 'formSysPost',
        meta: { title: '岗位管理' },
      },
      {
        path: 'formSysDeptPost',
        component: () => import('@/pages/upms/formSysDeptPost/index.vue'),
        name: 'formSysDeptPost',
        props: getProps,
        meta: { title: '设置部门岗位' },
      },
      {
        path: 'formSysDict',
        component: () => import('@/pages/upms/formSysDict/index.vue'),
        name: 'formSysDict',
        meta: { title: '字典管理' },
      },
      {
        path: 'formSysOperationLog',
        component: () => import('@/pages/upms/formSysOperationLog/index.vue'),
        name: 'formSysOperationLog',
        meta: { title: '操作日志' },
      },
      // 404
      {
        path: '/:pathMatch(.*)*',
        component: () => import('@/pages/error/404.vue'),
        name: 'NotFound',
        meta: {
          title: '404',
        },
      },
      // 在线表单
      {
        path: 'formOnlineDblink',
        component: () => import('@/pages/online/formOnlineDblink/index.vue'),
        name: 'formOnlineDblink',
        props: getProps,
        meta: { title: '数据库链接' },
      },
      {
        path: 'formOnlineDict',
        component: () => import('@/pages/online/formOnlineDict/index.vue'),
        name: 'formOnlineDict',
        props: getProps,
        meta: { title: '在线表单字典管理' },
      },
      {
        path: 'formOnlinePage',
        component: () => import('@/pages/online/formOnlinePage/index.vue'),
        name: 'formOnlinePage',
        props: getProps,
        meta: { title: '在线表单管理' },
      },
      {
        path: 'onlineForm',
        component: () => import('@/pages/online/OnlinePageRender/index.vue'),
        name: 'onlineForm',
        props: getProps,
        meta: { title: '在线表单' },
      },
      // 工作流模块
      {
        path: 'formMessage',
        component: () => import('@/pages/workflow/formMessage/index.vue'),
        name: 'formMessage',
        props: getProps,
        meta: { title: '催办消息' },
      },
      {
        path: 'formFlowCategory',
        component: () => import('@/pages/workflow/flowCategory/formFlowCategory.vue'),
        name: 'formFlowCategory',
        props: getProps,
        meta: { title: '流程分类管理' },
      },
      {
        path: 'formFlowEntry',
        component: () => import('@/pages/workflow/flowEntry/formFlowEntry.vue'),
        name: 'formFlowEntry',
        props: getProps,
        meta: { title: '流程设计' },
      },
      {
        path: 'formFlowDblink',
        component: () => import('@/pages/workflow/formFlowDblink/index.vue'),
        name: 'formFlowDblink',
        props: getProps,
        meta: { title: '流程数据库链接' },
      },
      {
        path: 'formAllInstance',
        component: () => import('@/pages/workflow/taskManager/formAllInstance.vue'),
        name: 'formAllInstance',
        props: getProps,
        meta: { title: '流程实例' },
      },
      {
        path: 'handlerFlowTask',
        component: () => import('@/pages/workflow/handlerFlowTask/index.vue'),
        name: 'handlerFlowTask',
        props: getProps,
        meta: { title: '流程处理' },
        children: [
          // 静态表单路由设置
        ],
      },
      {
        path: 'formMyTask',
        component: () => import('@/pages/workflow/taskManager/formMyTask.vue'),
        name: 'formMyTask',
        props: getProps,
        meta: { title: '我的待办' },
      },
      {
        path: 'formMyApprovedTask',
        component: () => import('@/pages/workflow/taskManager/formMyApprovedTask.vue'),
        name: 'formMyApprovedTask',
        props: getProps,
        meta: { title: '已办任务' },
      },
      {
        path: 'formMyHistoryTask',
        component: () => import('@/pages/workflow/taskManager/formMyHistoryTask.vue'),
        name: 'formMyHistoryTask',
        props: getProps,
        meta: { title: '历史流程' },
      },
      {
        path: 'formCompanies',
        component: () => import('@/pages/generated/formCompanies.vue'),
        name: 'formCompanies',
        props: getProps,
        meta: { title: '单位预览管理', keepalive: true },
      },
      {
        path: 'formAnalogtb',
        component: () => import('@/pages/qianduan/formAnalogtb.vue'),
        name: 'formAnalogtb',
        props: getProps,
        meta: { title: 'Analogtb管理', keepalive: true },
      },
      {
        path: 'formAreatb',
        component: () => import('@/pages/qianduan/formAreatb.vue'),
        name: 'formAreatb',
        props: getProps,
        meta: { title: 'Areatb管理', keepalive: true },
      },
      {
        path: 'formBuildingtb',
        component: () => import('@/pages/qianduan/formBuildingtb.vue'),
        name: 'formBuildingtb',
        props: getProps,
        meta: { title: 'Buildingtb管理', keepalive: true },
      },
      {
        path: 'formControllertb',
        component: () => import('@/pages/qianduan/formControllertb.vue'),
        name: 'formControllertb',
        props: getProps,
        meta: { title: 'Controllertb管理', keepalive: true },
      },
      {
        path: 'formCtrroomstb',
        component: () => import('@/pages/qianduan/formCtrroomstb.vue'),
        name: 'formCtrroomstb',
        props: getProps,
        meta: { title: 'Ctrroomstb管理', keepalive: true },
      },
      {
        path: 'formDevicetb',
        component: () => import('@/pages/qianduan/formDevicetb.vue'),
        name: 'formDevicetb',
        props: getProps,
        meta: { title: 'Devicetb管理', keepalive: true },
      },
      {
        path: 'formDevtypetb',
        component: () => import('@/pages/qianduan/formDevtypetb.vue'),
        name: 'formDevtypetb',
        props: getProps,
        meta: { title: 'Devtypetb管理', keepalive: true },
      },
      {
        path: 'formFactortstb',
        component: () => import('@/pages/qianduan/formFactortstb.vue'),
        name: 'formFactortstb',
        props: getProps,
        meta: { title: 'Factortstb管理', keepalive: true },
      },
      {
        path: 'formLayertb',
        component: () => import('@/pages/qianduan/formLayertb.vue'),
        name: 'formLayertb',
        props: getProps,
        meta: { title: 'Layertb管理', keepalive: true },
      },
      {
        path: 'formLooptb',
        component: () => import('@/pages/qianduan/formLooptb.vue'),
        name: 'formLooptb',
        props: getProps,
        meta: { title: 'Looptb管理', keepalive: true },
      },
      {
        path: 'formMultiwiredialtb',
        component: () => import('@/pages/qianduan/formMultiwiredialtb.vue'),
        name: 'formMultiwiredialtb',
        props: getProps,
        meta: { title: 'Multiwiredialtb管理', keepalive: true },
      },
      {
        path: 'formAttendants',
        component: () => import('@/pages/yunpingtai/formAttendants.vue'),
        name: 'formAttendants',
        props: getProps,
        meta: { title: '1Attendants管理', keepalive: true },
      },
      {
        path: 'formConfigs',
        component: () => import('@/pages/yunpingtai/formConfigs.vue'),
        name: 'formConfigs',
        props: getProps,
        meta: { title: '1Configs管理', keepalive: true },
      },
      {
        path: 'formDrillrecords',
        component: () => import('@/pages/yunpingtai/formDrillrecords.vue'),
        name: 'formDrillrecords',
        props: getProps,
        meta: { title: '1Drillrecords管理', keepalive: true },
      },
      {
        path: 'formDutyrecords',
        component: () => import('@/pages/yunpingtai/formDutyrecords.vue'),
        name: 'formDutyrecords',
        props: getProps,
        meta: { title: '1Dutyrecords管理', keepalive: true },
      },
      {
        path: 'formDutyrecordsplat',
        component: () => import('@/pages/yunpingtai/formDutyrecordsplat.vue'),
        name: 'formDutyrecordsplat',
        props: getProps,
        meta: { title: 'Dutyrecordsplat管理', keepalive: true },
      },
      {
        path: 'formGatewayrecords',
        component: () => import('@/pages/yunpingtai/formGatewayrecords.vue'),
        name: 'formGatewayrecords',
        props: getProps,
        meta: { title: '1Gatewayrecords管理', keepalive: true },
      },
      {
        path: 'formGateways',
        component: () => import('@/pages/yunpingtai/formGateways.vue'),
        name: 'formGateways',
        props: getProps,
        meta: { title: '1Gateways管理', keepalive: true },
      },
      {
        path: 'formInspectrecords',
        component: () => import('@/pages/yunpingtai/formInspectrecords.vue'),
        name: 'formInspectrecords',
        props: getProps,
        meta: { title: '1Inspectrecords管理', keepalive: true },
      },
      {
        path: 'formLocaltcprecords',
        component: () => import('@/pages/yunpingtai/formLocaltcprecords.vue'),
        name: 'formLocaltcprecords',
        props: getProps,
        meta: { title: '1Localtcprecords管理', keepalive: true },
      },
      {
        path: 'formOnofflinerecords',
        component: () => import('@/pages/yunpingtai/formOnofflinerecords.vue'),
        name: 'formOnofflinerecords',
        props: getProps,
        meta: { title: '1Onofflinerecords管理', keepalive: true },
      },
      {
        path: 'formOperationsplat',
        component: () => import('@/pages/yunpingtai/formOperationsplat.vue'),
        name: 'formOperationsplat',
        props: getProps,
        meta: { title: '1Operationsplat管理', keepalive: true },
      },
      {
        path: 'formPageevents',
        component: () => import('@/pages/yunpingtai/formPageevents.vue'),
        name: 'formPageevents',
        props: getProps,
        meta: { title: '1Pageevents管理', keepalive: true },
      },
      {
        path: 'formProjecttb',
        component: () => import('@/pages/yunpingtai/formProjecttb.vue'),
        name: 'formProjecttb',
        props: getProps,
        meta: { title: '项目预览', keepalive: true },
      },
      {
        path: 'formDevStatusHistory',
        component: () => import('@/pages/qianduan/formDevStatusHistory.vue'),
        name: 'formDevStatusHistory',
        props: getProps,
        meta: { title: '设备状态历史记录', keepalive: true },
      },
      {
        path: 'formPutoffrecords',
        component: () => import('@/pages/yunpingtai/formPutoffrecords.vue'),
        name: 'formPutoffrecords',
        props: getProps,
        meta: { title: '1Putoffrecords管理', keepalive: true },
      },
      {
        path: 'formRepairrecords',
        component: () => import('@/pages/yunpingtai/formRepairrecords.vue'),
        name: 'formRepairrecords',
        props: getProps,
        meta: { title: '1Repairrecords管理', keepalive: true },
      },
      {
        path: 'formStorageboxtb',
        component: () => import('@/pages/yunpingtai/formStorageboxtb.vue'),
        name: 'formStorageboxtb',
        props: getProps,
        meta: { title: '1Storageboxtb管理', keepalive: true },
      },
      {
        path: 'formStorageboxtypetb',
        component: () => import('@/pages/yunpingtai/formStorageboxtypetb.vue'),
        name: 'formStorageboxtypetb',
        props: getProps,
        meta: { title: '1Storageboxtypetb管理', keepalive: true },
      },
      {
        path: 'formSuppliestb',
        component: () => import('@/pages/yunpingtai/formSuppliestb.vue'),
        name: 'formSuppliestb',
        props: getProps,
        meta: { title: '1Suppliestb管理', keepalive: true },
      },
      {
        path: 'formSystypetb',
        component: () => import('@/pages/yunpingtai/formSystypetb.vue'),
        name: 'formSystypetb',
        props: getProps,
        meta: { title: '1Systypetb管理', keepalive: true },
      },
      {
        path: 'formTimeoutrecords',
        component: () => import('@/pages/yunpingtai/formTimeoutrecords.vue'),
        name: 'formTimeoutrecords',
        props: getProps,
        meta: { title: '1Timeoutrecords管理', keepalive: true },
      },
    ],
  },
  // 第三方接入路由
  // {
  //   path: '/thirdParty',
  //   component: () => import('@/components/thirdParty/index.vue'),
  //   name: 'thirdParty',
  //   props: getProps,
  //   children: [
  //     // 流程分类列表
  //     {
  //       path: 'thirdFormFlowCategory',
  //       name: 'thirdFormFlowCategory',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/flowCategory/formFlowCategory.vue'),
  //     },
  //     // 流程分类 新增、编辑
  //     {
  //       path: 'thirdAddFormFlowCategory',
  //       name: 'thirdAddFormFlowCategory',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/flowCategory/formEditFlowCategory.vue'),
  //     },
  //     // 流程实例列表
  //     {
  //       path: 'thirdFormAllInstance',
  //       name: 'thirdFormAllInstance',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/taskManager/formAllInstance.vue'),
  //     },
  //     // 流程图
  //     {
  //       path: 'thirdFormTaskProcessViewer',
  //       name: 'thirdFormTaskProcessViewer',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/taskManager/formTaskProcessViewer.vue'),
  //     },
  //     // 流程终止
  //     {
  //       path: 'thirdFormStopTaskInstance',
  //       name: 'thirdFormStopTaskInstance',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/taskManager/stopTask.vue'),
  //     },
  //     // 选择用户-处理用户
  //     {
  //       path: 'thirdTaskUserSelect',
  //       name: 'thirdTaskUserSelect',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/components/TaskUserSelect.vue'),
  //     },
  //     // 选择用户-跳转节点
  //     {
  //       path: 'thirdSelectUserTask',
  //       name: 'thirdSelectUserTask',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/components/UserTaskSelect/userTaskSelectDlg.vue'),
  //     },
  //     // 流程设计
  //     {
  //       path: 'thirdEditFlowDblink',
  //       name: 'thirdEditFlowDblink',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/formFlowDblink/editFlowDblink.vue'),
  //     },
  //     {
  //       path: 'thirdFormFlowEntry',
  //       name: 'thirdFormFlowEntry',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/flowEntry/formFlowEntry.vue'),
  //     },
  //     {
  //       path: 'thirdFormEditFlowEntry',
  //       name: 'thirdFormEditFlowEntry',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/flowEntry/formEditFlowEntry.vue'),
  //     },
  //     {
  //       path: 'thirdFormPublishedFlowEntry',
  //       name: 'thirdFormPublishedFlowEntry',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/flowEntry/formPublishedFlowEntry.vue'),
  //     },
  //     {
  //       path: 'thirdHandlerFlowTask',
  //       name: 'thirdHandlerFlowTask',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/handlerFlowTask/index.vue'),
  //     },
  //     // 流程设计-候选用户组
  //     {
  //       path: 'thirdTaskGroupSelect',
  //       name: 'thirdTaskGroupSelect',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/components/TaskGroupSelect.vue'),
  //     },
  //     // 流程设计-选择岗位
  //     {
  //       path: 'thirdTaskPostSelect',
  //       name: 'thirdTaskPostSelect',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/components/TaskPostSelect.vue'),
  //     },
  //     // 流程设计-抄送
  //     {
  //       path: 'thirdAddCopyForItem',
  //       name: 'thirdAddCopyForItem',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/components/CopyForSelect/addCopyForItem.vue'),
  //     },
  //     // 流程设计-任务操作按钮
  //     {
  //       path: 'thirdEditOperation',
  //       name: 'thirdEditOperation',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/package/refactor/form/formEditOperation.vue'),
  //     },
  //     // 流程设计-设置表单权限
  //     {
  //       path: 'thirdSetOnlineFormAuth',
  //       name: 'thirdSetOnlineFormAuth',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/package/refactor/form/formSetOnlineFormAuth.vue'),
  //     },
  //     // 流程设计-添加变量
  //     {
  //       path: 'thirdFormEditFlowEntryVariable',
  //       name: 'thirdFormEditFlowEntryVariable',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/flowEntry/formEditFlowEntryVariable.vue'),
  //     },
  //     // 流程设计- 新建状态
  //     {
  //       path: 'thirdFormEditFlowEntryStatus',
  //       name: 'thirdFormEditFlowEntryStatus',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/flowEntry/formEditFlowEntryStatus.vue'),
  //     },
  //     // 流程设计-新建状态
  //     {
  //       path: 'thirdTaskCommit',
  //       name: 'thirdTaskCommit',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/components/TaskCommit.vue'),
  //     },
  //     // 自动化任务 - 编辑过滤条件
  //     {
  //       path: 'thirdEditTableFilter',
  //       name: 'thirdEditTableFilter',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/package/refactor/form/editSrcTableFilter.vue'),
  //     },
  //     // 自动化任务 - 编辑更新字段
  //     {
  //       path: 'thirdEditFieldUpdateData',
  //       name: 'thirdEditFieldUpdateData',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/package/refactor/form/editInsertData.vue'),
  //     },
  //     // 自动化任务 - 编辑响应字段
  //     {
  //       path: 'thirdEditResponseData',
  //       name: 'thirdEditResponseData',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/package/refactor/form/editResponseData.vue'),
  //     },
  //     // 自动化任务 - 编辑HTTP请求参数
  //     {
  //       path: 'thirdEditHttpRequestParam',
  //       name: 'thirdEditHttpRequestParam',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/package/refactor/form/editHttpParameter.vue'),
  //     },
  //     // 自动化任务 - 编辑HTTP请求头
  //     {
  //       path: 'thirdEditHttpHeader',
  //       name: 'thirdEditHttpHeader',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/package/refactor/form/editHttpHeader.vue'),
  //     },
  //     // 待办任务
  //     {
  //       path: 'thirdFormMyTask',
  //       name: 'thirdFormMyTask',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/taskManager/formMyTask.vue'),
  //     },
  //     // 历史任务
  //     {
  //       path: 'thirdFormMyHistoryTask',
  //       name: 'thirdFormMyHistoryTask',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/taskManager/formMyHistoryTask.vue'),
  //     },
  //     // 已办任务
  //     {
  //       path: 'thirdFormMyApprovedTask',
  //       name: 'thirdFormMyApprovedTask',
  //       props: getProps,
  //       component: () => import('@/pages/workflow/taskManager/formMyApprovedTask.vue'),
  //     },
  //     // 在线表单部分
  //     {
  //       path: 'thirdOnlineForm',
  //       name: 'thirdOnlineForm',
  //       props: getProps,
  //       component: () => import('@/pages/online/OnlinePageRender/index.vue'),
  //     },
  //     {
  //       path: 'thirdOnlineEditForm',
  //       name: 'thirdOnlineEditForm',
  //       props: getProps,
  //       component: () => import('@/pages/online/OnlinePageRender/OnlineEditForm/index.vue'),
  //     },
  //     {
  //       path: 'thirdFormOnlineDict',
  //       name: 'thirdFormOnlineDict',
  //       props: getProps,
  //       component: () => import('@/pages/online/formOnlineDict/index.vue'),
  //     },
  //     {
  //       path: 'thirdEditOnlineDict',
  //       name: 'thirdEditOnlineDict',
  //       props: getProps,
  //       component: () => import('@/pages/online/formOnlineDict/EditOnlineDict.vue'),
  //     },
  //     {
  //       path: 'thirdOnlinePage',
  //       name: 'thirdOnlinePage',
  //       props: getProps,
  //       component: () => import('@/pages/online/formOnlinePage/index.vue'),
  //     },
  //     {
  //       path: 'thirdEditOnlinePage',
  //       name: 'thirdEditOnlinePage',
  //       props: getProps,
  //       component: () => import('@/pages/online/editOnlinePage/index.vue'),
  //     },
  //     {
  //       path: 'thirdEditOnlineForm',
  //       name: 'thirdEditOnlineForm',
  //       props: getProps,
  //       component: () => import('@/pages/online/editOnlinePage/editOnlineForm.vue'),
  //     },
  //     {
  //       path: 'thirdEditPageDatasource',
  //       name: 'thirdEditPageDatasource',
  //       props: getProps,
  //       component: () => import('@/pages/online/editOnlinePage/editOnlinePageDatasource.vue'),
  //     },
  //     {
  //       path: 'thirdEditPageRelation',
  //       name: 'thirdEditPageRelation',
  //       props: getProps,
  //       component: () =>
  //         import('@/pages/online/editOnlinePage/editOnlinePageDatasourceRelation.vue'),
  //     },
  //     {
  //       path: 'thirdSetOnlineTableColumnRule',
  //       name: 'thirdSetOnlineTableColumnRule',
  //       props: getProps,
  //       component: () => import('@/pages/online/editOnlinePage/setOnlineTableColumnRule.vue'),
  //     },
  //     {
  //       path: 'thirdEditVirtualColumnFilter',
  //       name: 'thirdEditVirtualColumnFilter',
  //       props: getProps,
  //       component: () => import('@/pages/online/editOnlinePage/editVirtualColumnFilter.vue'),
  //     },
  //     {
  //       path: 'thirdEditTableColumn',
  //       name: 'thirdEditTableColumn',
  //       props: getProps,
  //       component: () => import('@/pages/online/editOnlinePage/formDesign/editTableColumn.vue'),
  //     },
  //     {
  //       path: 'thirdEditCustomFormOperate',
  //       name: 'thirdEditCustomFormOperate',
  //       props: getProps,
  //       component: () =>
  //         import('@/pages/online/editOnlinePage/formDesign/components/EditCustomFormOperate.vue'),
  //     },
  //     {
  //       path: 'thirdEditFormField',
  //       name: 'thirdEditFormField',
  //       props: getProps,
  //       component: () =>
  //         import('@/pages/online/editOnlinePage/formDesign/components/EditFormField.vue'),
  //     },
  //     {
  //       path: 'thirdEditDictParamValue',
  //       name: 'thirdEditDictParamValue',
  //       props: getProps,
  //       component: () =>
  //         import(
  //           '@/pages/online/editOnlinePage/formDesign/components/CustomWidgetDictSetting/EditDictParamValue.vue'
  //         ),
  //     },
  //     {
  //       path: 'thirdEditOnlineTableColumn',
  //       name: 'thirdEditOnlineTableColumn',
  //       props: getProps,
  //       component: () =>
  //         import(
  //           '@/pages/online/editOnlinePage/formDesign/components/OnlineTableColumnSetting/editOnlineTableColumn.vue'
  //         ),
  //     },
  //     {
  //       path: 'thirdEditOnlineTabPanel',
  //       name: 'thirdEditOnlineTabPanel',
  //       props: getProps,
  //       component: () =>
  //         import(
  //           '@/pages/online/editOnlinePage/formDesign/components/OnlineTabPanelSetting/editOnlineTabPanel.vue'
  //         ),
  //     },
  //     {
  //       path: 'thirdOnlineDblink',
  //       name: 'thirdOnlineDblink',
  //       props: getProps,
  //       component: () => import('@/pages/online/formOnlineDblink/index.vue'),
  //     },
  //     {
  //       path: 'thirdEditOnlineDblink',
  //       name: 'thirdEditOnlineDblink',
  //       props: getProps,
  //       component: () => import('@/pages/online/formOnlineDblink/EditOnlineDblink.vue'),
  //     },
  //     // 通用
  //     {
  //       path: 'thirdEditDictParamValue2',
  //       name: 'thirdEditDictParamValue2',
  //       props: getProps,
  //       component: () =>
  //         import(
  //           '@/online/components/WidgetAttributeSetting/components/CustomWidgetDictSetting/editDictParamValue.vue'
  //         ),
  //     },
  //     {
  //       path: 'thirdEditOnlineTableColumn2',
  //       name: 'thirdEditOnlineTableColumn2',
  //       props: getProps,
  //       component: () =>
  //         import(
  //           '@/online/components/WidgetAttributeSetting/components/OnlineTableColumnSetting/editOnlineTableColumn.vue'
  //         ),
  //     },
  //     {
  //       path: 'thirdEditOnlineTabPanel2',
  //       name: 'thirdEditOnlineTabPanel2',
  //       props: getProps,
  //       component: () =>
  //         import(
  //           '@/online/components/WidgetAttributeSetting/components/OnlineTabPanelSetting/editOnlineTabPanel.vue'
  //         ),
  //     },
  //     {
  //       path: 'thirdSelectDept',
  //       name: 'thirdSelectDept',
  //       props: getProps,
  //       component: () => import('@/components/DeptSelect/DeptSelectDlg.vue'),
  //     },
  //     {
  //       path: 'thirdSelectUser',
  //       name: 'thirdSelectUser',
  //       props: getProps,
  //       component: () => import('@/components/UserSelect/UserSelectDlg.vue'),
  //     },
  //   ],
  // },
];
